
// document js begin
$(document).ready(function() {
  
  // sidebar b
  var trigger = $('.hamburger'),
  overlay = $('.overlay'),
  isClosed = false;
  trigger.click(function () {
    hamburger_cross();
  });
  function hamburger_cross() {
    if (isClosed == true) {
      overlay.hide();
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      event.preventDefault();
      $('body').css('overflow', 'auto');
    } else {
      overlay.show();
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      event.preventDefault();
      $('body').css('overflow', 'hidden');
    }
  }
  overlay.click(function () {
    overlay_cross();
  });
  function overlay_cross() {
    if (isClosed == true) {
      overlay.hide();
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      event.preventDefault();
      $('body').css('overflow', 'auto');
    } else {
      overlay.show();
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      event.preventDefault();
      $('body').css('overflow', 'hidden');

    }
    $('#warper').toggleClass('toggled');
  }
  $('[data-toggle="offcanvas"]').click(function () {
        $('#warper').toggleClass('toggled');
  });
  // sidebar e

  
  $(".nav").slide({ type:"menu", titCell:".m", targetCell:".sub",effect:"slideDown",delayTime:300,triggerTime:0,returnDefault:true,defaultPlay:false});


  $('[data-fancybox="images"]').fancybox({
    thumbs : {
      autoStart : false
    }
  });

  //首页banner
  var indexBanner = new Swiper ('.index_banner', {
    autoplay : 8000,
    autoplayDisableOnInteraction : false,
    loop: true,
    lazyLoading : true,
    pagination: '.index_banner_page',
    paginationClickable :true,
    paginationBulletRender: function (swiper, index, className) {
        return '<span class="' + className + '">0' + (index + 1) + '</span>';
    },
    nextButton: '.index_banner_next',
    prevButton: '.index_banner_prev',
    onInit: function(swiper){
      swiperAnimateCache(swiper);
      swiperAnimate(swiper);
    }, 
    onSlideChangeEnd: function(swiper){ 
      swiperAnimate(swiper);
    }
  });

  //首页产品
  var indexProduct = new Swiper ('.index_product_list', {
    autoplay : 8000,
    autoplayDisableOnInteraction : false,
    loop: false,
    lazyLoading : true,
    pagination: '.index_product_list_page',
    paginationClickable :true,
    paginationBulletRender: function (swiper, index, className) {
      var stitle = document.querySelectorAll('.index_product_list .swiper-slide')[index].getAttribute('data-stitle');
      return '<span class="' + className + '">' + stitle + '</span>';
    },
    nextButton: '.index_product_list_next',
    prevButton: '.index_product_list_prev'
  });

  //首页新闻
  var indexNews = new Swiper ('.index_news_list', {
    autoplay : 8000,
    autoplayDisableOnInteraction : false,
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 20,
    loop: true,
    lazyLoading : true,
    pagination: '.index_news_list_page',
    paginationClickable :true,
    nextButton: '.index_news_list_next',
    prevButton: '.index_news_list_prev',
    breakpoints: {
      450: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      968: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      }
    }
  });

  //首页banner
  var hotNews = new Swiper ('.hotnews_list', {
    autoplay : 8000,
    autoplayDisableOnInteraction : false,
    loop: true,
    lazyLoading : true,
    pagination: '.hotnews_list_page',
    paginationClickable :true,
  });




});
// document js begin

// resize --------------------------------------------------------------------------------
$(window).resize(function() {

    $windowW = $(window).width();
    $windowH = $(window).height();

    $('.winH').css('height', $windowH);
    $headerH = $('header').height();
    $pcheaderH = $('.pc_head').height();
    $('.winInnerH').css('height', $windowH-$pcheaderH);

    if ( $windowW > 1180 ) {

      $(".project_item").mCustomScrollbar({
        theme:"dark"
      });

    } else {
      
    }
    if ( $windowW > 668 ) {
    }

}).trigger('resize');
// resize --------------------------------------------------------------------------------



//下拉头部添加class
$(window).scroll(function(){
  //if($(window).width() > 1024){
      if($(window).scrollTop() >= $headerH){
        $("header").addClass('move');
      } else{
        $("header").addClass('move').removeClass('move');
      }
  //}
});